<div class="action-arrow__content">
	<a class="action-icon action-icon-active" (click)="onEditProducts()">
		<i class="fas fa-edit active"></i>
	</a>
</div>
